// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

import type { MapStateToProps } from 'react-redux';

import EventContainer from './calendar.event-container.js';
import Indication from '../../ui/indication.js';

import Select from '../../form/select.js';
import SortingArrows from '../sorting-arrows.js';
import { setModal } from '../../ui/ui.actions.js';

import { dateFormatSettings, timeFormatSettings } from '../../settings/settings.consts.js';

import { selectUIMessages, selectAssignToOptions } from '../calendar.selectors.js';

import {
  saveDiscrepancy,
  changeStatus,
  editComment,
  addComment,
  deleteDiscrepancy
} from '../calendar-day.actions.js';

import {
  DISCREPANCY_VIEW,
  activityNames,
  discrepancyFields,
  statusNames,
  statusOptions,
  discrepancyPriorities,
  priorityOptions,
  ASC
} from '../calendar.consts.js';

import { formatDate, getAccurateTimestamp, getDiscrepancyFieldValue } from '../calendar.model.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

function Activity({
  UI,
  setModal,
  activity,
  mechanics,
  mechanicsList,
  fieldAttrs,
  onEditComment,
  accessgroups,
  user
}) {
  return (
    <tr>
      <td colSpan="2">
        <b>
          {activity.authorName} {activity.authorSurname}
        </b>{' '}
        -{' '}
        <b>
          {activityNames[activity.action]} {discrepancyFields[activity.fieldName]}
        </b>{' '}
        {formatDate(
          getAccurateTimestamp(activity.date),
          0,
          `${dateFormatSettings[user.settings.date]} ${timeFormatSettings[user.settings.time]}`
        )}
        {activity.action === 'save' || activity.action === 'changeStatus' ? (
          <div>
            <div className="activity-field">
              <b>Original Value</b>
              <br />
              <span>
                {activity.beforeValue
                  ? getDiscrepancyFieldValue(
                      activity.fieldName,
                      activity.beforeValue,
                      mechanics,
                      mechanicsList
                    )
                  : '—'}
              </span>
            </div>
            <div className="activity-field">
              <b>New Value</b>
              <br />
              <span>
                {activity.afterValue
                  ? getDiscrepancyFieldValue(
                      activity.fieldName,
                      activity.afterValue,
                      mechanics,
                      mechanicsList
                    )
                  : '—'}
              </span>
            </div>
          </div>
        ) : null}
        {activity.action === 'comment' ? (
          <div>
            <b>Comment</b>
            <br />
            {accessgroups.discrepanciesComment ? (
              UI.modals[`edit-comment-${activity.id}`] ? (
                <div>
                  <div className="form-group">
                    <textarea
                      className="form-control input-sm"
                      name={`discrepancy.activities.${activity.id}.newDisposition`}
                      rows="4"
                      value={activity.newDisposition || activity.disposition}
                      {...fieldAttrs}
                    />
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-sm btn-default"
                      data-id={activity.id}
                      onClick={onEditComment}
                      disabled={UI.progress}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-sm btn-default"
                      onClick={setModal.bind(this, false, `edit-comment-${activity.id}`)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <span
                  disabled={UI.progress}
                  className="clickable-link activity-field-comment"
                  onClick={setModal.bind(this, true, `edit-comment-${activity.id}`)}
                >
                  {activity.disposition}
                  <span className="icon pencil" />
                </span>
              )
            ) : (
              <span>{activity.disposition}</span>
            )}
          </div>
        ) : null}
      </td>
    </tr>
  );
}

class DiscrepancyView extends React.Component<Props> {
  static footer = true;

  constructor(props: Props) {
    super(props);
    this.handleDiscrepancyDelete = this.handleDiscrepancyDelete.bind(this);
    this.handleDiscrepancySave = this.handleDiscrepancySave.bind(this);
    this.handleDiscrepancyChange = this.handleDiscrepancyChange.bind(this);

    this.handleSortingClick = this.handleSortingClick.bind(this);

    this.handleDiscrepancyEditModalOpen = this.handleDiscrepancyEditModalToggle.bind(this);
    this.handleDiscrepancyEditModalClose = this.handleDiscrepancyEditModalToggle.bind(this, false);

    this.handleEditComment = this.handleEditComment.bind(this);
    this.handleCalcelComment = this.handleCalcelComment.bind(this);
  }

  handleDiscrepancyDelete: Function;
  handleDiscrepancyDelete(e) {
    return confirm('Delete discrepancy?') ? this.props.deleteDiscrepancy() : false;
  }

  handleCalcelComment: Function;
  handleCalcelComment(e) {
    this.props.setModal(false, 'discrepancyComment');
    return this.props.fieldAttrs.onChange('discrepancy.disposition', '');
  }

  handleEditComment: Function;
  handleEditComment(e) {
    const { id } = e.currentTarget.dataset;
    return this.props.editComment(id, this.props.discrepancy.activities[id].newDisposition);
  }

  handleDiscrepancySave: Function;
  handleDiscrepancySave(field) {
    this.props.setModal(false, `DISCR-FULL-EDIT-${field}`);
    return this.props.saveDiscrepancy(this.props.discrepancy.id, this.props.discrepancy);
  }

  handleDiscrepancyEditModalToggle: Function;
  handleDiscrepancyEditModalToggle(field) {
    const activeDiscrepancyEdit = Object.keys(this.props.UI.modals).find(key =>
      key.includes('DISCR-FULL-EDIT-')
    );

    if (activeDiscrepancyEdit) this.props.setModal(false, activeDiscrepancyEdit);
    if (field) return this.props.setModal(true, `DISCR-FULL-EDIT-${field}`);

    return true;
  }

  handleDiscrepancyChange: Function;
  handleDiscrepancyChange(field, value) {
    this.props.setModal(false, `DISCR-FULL-EDIT-${field}`);
    if (field === 'status') {
      return this.props.changeStatus(this.props.discrepancy.id, value);
    }
    if (field === 'assignTo') {
      return this.props.saveDiscrepancy(this.props.discrepancy.id, {
        [field]: value,
        assignedName: this.props.mechanics[value].name,
        assignedSurname: this.props.mechanics[value].surname
      });
    }
    return this.props.saveDiscrepancy(this.props.discrepancy.id, { [field]: value });
  }

  handleSortingClick: Function;
  handleSortingClick(e) {
    const { direction } = e.currentTarget.dataset;
    if (this.props.discrepancy.sortingDirection === direction) return false;
    return this.props.fieldAttrs.onChange('discrepancy.sortingDirection', direction);
  }

  render() {
    const { UI, user, discrepancy, accessgroups, fieldAttrs } = this.props;

    if (!accessgroups.discrepanciesView || (!discrepancy || !discrepancy.id))
      return <Indication className="event-form-indication" messages={this.props.UIMessages} />;

    const sortedActivities =
      !discrepancy.sortingDirection || discrepancy.sortingDirection === ASC
        ? discrepancy.activitiesList
        : [...discrepancy.activitiesList].reverse();

    return (
      <EventContainer>
        <div className="row">
          <div className="col-sm-5">
            <div className="form-group">
              <label
                className={`input-sm discrepancy-field
                    ${UI.modals['DISCR-FULL-EDIT-name'] ? 'required-label' : ''}
                `}
              >
                Name
              </label>
              {UI.modals['DISCR-FULL-EDIT-name'] ? (
                accessgroups.discrepanciesManage ? (
                  <div className="input-group">
                    <input
                      id="discrepancy-name"
                      type="text"
                      name="discrepancy.name"
                      maxLength="100"
                      size="10"
                      className="form-control discrepancy-field"
                      value={discrepancy.name}
                      {...fieldAttrs}
                      required
                    />
                    {discrepancy.name.length ? (
                      <span
                        className="discrepancy-field input-group-addon success"
                        onClick={this.handleDiscrepancySave.bind(this, 'name')}
                      >
                        <span className="icon checkmark" />
                      </span>
                    ) : null}
                    <span
                      className="discrepancy-field input-group-addon"
                      onClick={this.handleDiscrepancyEditModalClose}
                    >
                      <span className="icon close" />
                    </span>
                  </div>
                ) : null
              ) : (
                <div
                  className={`discrepancy-field form-control-static no-border
                      ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                  onClick={
                    accessgroups.discrepanciesManage
                      ? this.handleDiscrepancyEditModalOpen.bind(this, 'name')
                      : null
                  }
                >
                  {discrepancy.name}
                  <span className="discrepancy-field-view-icon">
                    <span className="icon pencil" />
                  </span>
                </div>
              )}
            </div>

            <div className="form-group">
              <label
                className={`input-sm discrepancy-field
                    ${UI.modals['DISCR-FULL-EDIT-assignTo'] ? 'required-label' : ''}
                `}
              >
                Assigned To
              </label>
              {UI.modals['DISCR-FULL-EDIT-assignTo'] ? (
                accessgroups.discrepanciesManage ? (
                  <Select
                    pretty
                    searchable={false}
                    clearable={false}
                    disabled={UI.progress}
                    placeholder="Select Mechanic"
                    className="discrepancy-field"
                    options={this.props.assignToOptions}
                    value={discrepancy.assignTo}
                    onChange={this.handleDiscrepancyChange.bind(this, 'assignTo')}
                  />
                ) : null
              ) : (
                <div
                  className={`discrepancy-field form-control-static no-border
                      ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                  onClick={
                    accessgroups.discrepanciesManage
                      ? this.handleDiscrepancyEditModalOpen.bind(this, 'assignTo')
                      : null
                  }
                >
                  {discrepancy.assignTo ? (
                    <span>
                      {discrepancy.assignedName} {discrepancy.assignedSurname}
                    </span>
                  ) : (
                    <span>None</span>
                  )}
                  <span className="discrepancy-field-view-icon">
                    <span className="icon pencil" />
                  </span>
                </div>
              )}
            </div>

            <div className="form-group">
              <label className="input-sm">Report By</label>
              <div className="discrepancy-field form-control-static no-edit">
                <div className="discrepancy-field-view-block">
                  {discrepancy.authorName} {discrepancy.authorSurname}
                </div>
              </div>
            </div>

            {discrepancy.status === 'closed' ? (
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="discrepancy.logbookEntryCheck"
                    checked={
                      discrepancy.logbookEntryCheck === '1' || discrepancy.logbookEntry.length
                    }
                    value="1"
                    {...fieldAttrs}
                  />
                  <b>Add a Logbook Entry</b>
                </label>
              </div>
            ) : null}

            {discrepancy.status === 'closed' &&
            (discrepancy.logbookEntryCheck === '1' || discrepancy.logbookEntry.length) ? (
              <div className="form-group">
                <label
                  className={`input-sm discrepancy-field
                        ${UI.modals['DISCR-FULL-EDIT-entry'] ? 'required-label' : ''}
                    `}
                >
                  Logbook Entry
                </label>
                {UI.modals['DISCR-FULL-EDIT-entry'] ? (
                  accessgroups.discrepanciesManage ? (
                    <div className="input-group">
                      <textarea
                        id="discrepancy-entry"
                        type="text"
                        name="discrepancy.logbookEntry"
                        rows="4"
                        className="form-control discrepancy-field"
                        value={discrepancy.logbookEntry}
                        {...fieldAttrs}
                        required
                      />
                      {discrepancy.logbookEntry.length ? (
                        <span
                          className="discrepancy-field input-group-addon success"
                          onClick={this.handleDiscrepancySave.bind(this, 'entry')}
                        >
                          <span className="icon checkmark" />
                        </span>
                      ) : null}
                      <span
                        className="discrepancy-field input-group-addon"
                        onClick={this.handleDiscrepancyEditModalClose}
                      >
                        <span className="icon close" />
                      </span>
                    </div>
                  ) : null
                ) : (
                  <div
                    className={`discrepancy-field form-control-static no-border textarea-field
                            ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                    onClick={
                      accessgroups.discrepanciesManage
                        ? this.handleDiscrepancyEditModalOpen.bind(this, 'entry')
                        : null
                    }
                  >
                    {discrepancy.logbookEntry || 'None'}
                    <span className="discrepancy-field-view-icon">
                      <span className="icon pencil" />
                    </span>
                  </div>
                )}
              </div>
            ) : null}
          </div>

          <div className="col-sm-5 col-sm-offset-1">
            <div className="form-group">
              <label
                className={`input-sm discrepancy-field
                    ${UI.modals['DISCR-FULL-EDIT-status'] ? 'required-label' : ''}
                `}
              >
                Status
              </label>
              {UI.modals['DISCR-FULL-EDIT-status'] ? (
                accessgroups.discrepanciesStatus ? (
                  <Select
                    pretty
                    searchable={false}
                    clearable={false}
                    disabled={UI.progress}
                    placeholder="Select Mechanic"
                    className="discrepancy-field"
                    options={statusOptions}
                    value={discrepancy.status}
                    onChange={this.handleDiscrepancyChange.bind(this, 'status')}
                  />
                ) : null
              ) : (
                <div
                  className={`discrepancy-field form-control-static no-border
                      ${!accessgroups.discrepanciesStatus ? ' no-edit' : ''}`}
                  onClick={
                    accessgroups.discrepanciesStatus
                      ? this.handleDiscrepancyEditModalOpen.bind(this, 'status')
                      : null
                  }
                >
                  {statusNames[discrepancy.status]}
                  <span className="discrepancy-field-view-icon">
                    <span className="icon pencil" />
                  </span>
                </div>
              )}
            </div>

            <div className="form-group">
              <label
                className={`input-sm discrepancy-field
                    ${UI.modals['DISCR-FULL-EDIT-priority'] ? 'required-label' : ''}
                `}
              >
                Priority
              </label>
              {UI.modals['DISCR-FULL-EDIT-priority'] ? (
                accessgroups.discrepanciesManage ? (
                  <Select
                    pretty
                    searchable={false}
                    clearable={false}
                    disabled={UI.progress}
                    placeholder="Select Mechanic"
                    className="discrepancy-field"
                    options={priorityOptions}
                    value={discrepancy.priority}
                    onChange={this.handleDiscrepancyChange.bind(this, 'priority')}
                  />
                ) : null
              ) : (
                <div
                  className={`discrepancy-field form-control-static no-border
                      ${discrepancyPriorities[discrepancy.priority].className}
                      ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                  onClick={
                    accessgroups.discrepanciesManage
                      ? this.handleDiscrepancyEditModalOpen.bind(this, 'priority')
                      : null
                  }
                >
                  {discrepancyPriorities[discrepancy.priority].name}
                  <span className="discrepancy-field-view-icon">
                    <span className="icon pencil" />
                  </span>
                </div>
              )}
            </div>

            <div className="form-group">
              <label
                className={`input-sm discrepancy-field
                    ${UI.modals['DISCR-FULL-EDIT-description'] ? 'required-label' : ''}
                `}
              >
                Description
              </label>
              {UI.modals['DISCR-FULL-EDIT-description'] ? (
                accessgroups.discrepanciesManage ? (
                  <div className="input-group">
                    <textarea
                      id="discrepancy-description"
                      type="text"
                      name="discrepancy.description"
                      rows="4"
                      className="form-control discrepancy-field"
                      value={discrepancy.description}
                      {...fieldAttrs}
                      required
                    />
                    {discrepancy.description.length ? (
                      <span
                        className="discrepancy-field input-group-addon success"
                        onClick={this.handleDiscrepancySave.bind(this, 'description')}
                      >
                        <span className="icon checkmark" />
                      </span>
                    ) : null}
                    <span
                      className="discrepancy-field input-group-addon"
                      onClick={this.handleDiscrepancyEditModalClose}
                    >
                      <span className="icon close" />
                    </span>
                  </div>
                ) : null
              ) : (
                <div
                  className={`discrepancy-field form-control-static no-border textarea-field
                        ${!accessgroups.discrepanciesManage ? ' no-edit' : ''}`}
                  onClick={
                    accessgroups.discrepanciesManage
                      ? this.handleDiscrepancyEditModalOpen.bind(this, 'description')
                      : null
                  }
                >
                  {discrepancy.description || 'None'}
                  <span className="discrepancy-field-view-icon">
                    <span className="icon pencil" />
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th colSpan="2" className="clickable-link">
                  <h4 className="text-center">
                    History
                    <div className="sort-arrows pull-right">
                      <SortingArrows
                        field="history"
                        onClick={this.handleSortingClick}
                        sortingField="history"
                        sortingDirection={discrepancy.sortingDirection}
                      />
                    </div>
                  </h4>
                </th>
              </tr>
            </thead>

            {discrepancy.activitiesList.length ? (
              discrepancy.activitiesList.length > 3 && !UI.modals.showAllActivity ? (
                <tbody>
                  <tr
                    className="active"
                    onClick={this.props.setModal.bind(this, true, 'showAllActivity')}
                  >
                    <td colSpan="2" className="text-center">
                      <b>Show All (+ {discrepancy.activitiesList.length - 3})</b>
                    </td>
                  </tr>
                  {sortedActivities.map((activityID, i) => {
                    const activity = discrepancy.activities[activityID];
                    if (i > 2) return null;
                    return (
                      <Activity
                        UI={UI}
                        user={user}
                        activity={activity}
                        fieldAttrs={fieldAttrs}
                        accessgroups={accessgroups}
                        setModal={this.props.setModal}
                        mechanics={this.props.mechanics}
                        mechanicsList={this.props.mechanicsList}
                        key={`activity-show-${activity.id}`}
                        onEditComment={this.handleEditComment}
                      />
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  {discrepancy.activitiesList.length > 3 && UI.modals.showAllActivity ? (
                    <tr
                      onClick={this.props.setModal.bind(this, false, 'showAllActivity')}
                      className="active"
                    >
                      <td colSpan="2" className="text-center">
                        <b>Hide</b>
                      </td>
                    </tr>
                  ) : null}
                  {sortedActivities.map(activityID => {
                    const activity = discrepancy.activities[activityID];
                    return (
                      <Activity
                        UI={UI}
                        user={user}
                        activity={activity}
                        fieldAttrs={fieldAttrs}
                        accessgroups={accessgroups}
                        setModal={this.props.setModal}
                        key={`activity-${activity.id}`}
                        mechanics={this.props.mechanics}
                        mechanicsList={this.props.mechanicsList}
                        onEditComment={this.handleEditComment}
                      />
                    );
                  })}
                </tbody>
              )
            ) : (
              <tbody>
                <tr>
                  <td colSpan="2" className="text-center">
                    <p className="form-control-static">No activities defined</p>
                  </td>
                </tr>
              </tbody>
            )}
          </table>

          {accessgroups.discrepanciesComment ? (
            UI.modals.discrepancyComment ? (
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label className="input-sm">Comments</label>
                    <textarea
                      name="discrepancy.disposition"
                      className="form-control input-sm"
                      value={discrepancy.disposition}
                      {...fieldAttrs}
                      rows="4"
                    />
                  </div>
                  <div className="form-group">
                    <button
                      disabled={UI.progress}
                      className="btn btn-sm btn-default"
                      onClick={this.props.addComment}
                    >
                      Add
                    </button>
                    <button
                      disabled={UI.progress}
                      className="btn btn-sm btn-default"
                      onClick={this.handleCalcelComment}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="btn btn-sm btn-default"
                onClick={this.props.setModal.bind(this, true, 'discrepancyComment')}
              >
                <span className="icon comment" /> Comment
              </button>
            )
          ) : null}
        </div>

        <input
          id={DISCREPANCY_VIEW}
          onClick={this.handleDiscrepancyDelete}
          style={{ display: 'none' }}
        />
      </EventContainer>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UIMessages: selectUIMessages(DISCREPANCY_VIEW)(state),
  UI: state.UI,
  URL: state.URL,
  user: state.user,
  accessgroups: state.accessgroups,
  discrepancy: state.discrepancy,
  mechanics: state.mechanics,
  mechanicsList: state.mechanicsList,
  assignToOptions: selectAssignToOptions(state)
});

export default connect(
  mapStateToProps,
  {
    setModal,
    saveDiscrepancy,
    changeStatus,
    editComment,
    addComment,
    deleteDiscrepancy,
    ...formActions
  },
  mergeActionsToProps
)(DiscrepancyView);
